import React from 'react';

import CurrencyFormat from '../../../../components/CurrencyFormat';
import { PriceDetailsItem } from '../PriceDetails';
import type { Item } from './types';

const baseCls = 'checkout-summary-prices';

const FlightSummaryItem = ({
  name,
  price,
  icon,
  highlighted,
  tooltipText,
}: Item) => (
  <PriceDetailsItem
    label={name}
    highlighted={highlighted}
    tooltipText={tooltipText}
  >
    <div>
      {icon && <span className={`${baseCls}__icon`}>{icon}</span>}
      <CurrencyFormat value={price} />
    </div>
  </PriceDetailsItem>
);

export default FlightSummaryItem;
